import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';

const NewsletterSignup = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success', 'already', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/v1/newsletter/subscribe`, { email });
      setStatus(res.data.already_subscribed ? 'already' : 'success');
      if (!res.data.already_subscribed) setEmail('');
    } catch (err) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  if (status === 'success') {
    return (
      <div className={`newsletter-signup ${variant}`} data-testid="newsletter-success">
        <div className="newsletter-success">
          <span className="success-icon">✓</span>
          <span>You're subscribed! Check your inbox.</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`newsletter-signup ${variant}`} data-testid="newsletter-signup">
      <div className="newsletter-content">
        <h4>Weekly News Intelligence</h4>
        <p>Get the week's most interesting framing differences delivered to your inbox.</p>
      </div>
      <form className="newsletter-form" onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          data-testid="newsletter-email"
        />
        <button type="submit" disabled={loading} data-testid="newsletter-submit">
          {loading ? '...' : 'Subscribe'}
        </button>
      </form>
      {status === 'already' && (
        <p className="newsletter-note">You're already subscribed!</p>
      )}
      {status === 'error' && (
        <p className="newsletter-error">Something went wrong. Try again.</p>
      )}
    </div>
  );
};

export default NewsletterSignup;
